<div *ngIf="loading" class="w-100 d-flex align-items-center justify-content-center">
    <div class="w-25">
     <img class="loading" src="../../../../assets/images/login-in-progress.gif" />
    </div>
   </div>